import { UserModel } from '@app/src/views/Login/login/models/User';
import { LoginModelService } from '@app/src/views/Login/login/models/LoginService';

export const hydrateUser = (data: LoginModelService): UserModel => {

  let user: UserModel['user'] = {
    id: 0,
    username: '',
    alias: '',
    isAdmin: false,
    accessToken: '',
    reportToken: '',
    service: {
      id: 0,
      name: '',
      idCountry: 0,
      dateCreated: ''
    }
  };

  if(data.data) {
    user.accessToken = data.data.accessToken;
    user.reportToken = data.data.reportToken;
  }

  const dataHydrate: UserModel = {
    code: data.code,
    message: data.message,
    user: user
  };

  return dataHydrate;
}
